import { createFileRoute } from '@tanstack/react-router'
import { DatasetRecordView } from './-DatasetRecordView'

export const Route = createFileRoute('/datasets/$taskId/$recordId')({
  component: DatasetRecordPage,
})

function DatasetRecordPage() {
  const { taskId, recordId } = Route.useParams()
  return <DatasetRecordView key={`${taskId}:${recordId}`} taskId={taskId} recordId={recordId} />
}
